// import React, { useState } from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import {
//   Card,
//   Box,
//   Typography,
//   Button,
//   Stack,
//   useTheme,
//   Divider,
//   ToggleButtonGroup,
//   ToggleButton,
// } from "@mui/material";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// export interface RevenueDataPoint {
//   month: string;
//   totalRevenue: number; // The solid purple line
//   paymentsReceived: number; // The dashed red/pink line
//   otherSalesColor:number;
// }

// // Data adjusted to ensure 5M is the peak for the Y-Axis to display all ticks
// export const data: RevenueDataPoint[] = [
//   { month: "JAN", totalRevenue: 500000, paymentsReceived: 200000,otherSalesColor:100000 },
//   { month: "FEB", totalRevenue: 1000000, paymentsReceived: 400000,otherSalesColor:500000 },
//   { month: "MAR", totalRevenue: 2500000, paymentsReceived: 800000,otherSalesColor:200000},
//   { month: "APR", totalRevenue: 4000000, paymentsReceived: 1500000,otherSalesColor:140000 },
//   { month: "MAY", totalRevenue: 5000000, paymentsReceived: 3000000,otherSalesColor:250000 }, // Peak for 5M tick
//   { month: "JUN", totalRevenue: 3000000, paymentsReceived: 2500000,otherSalesColor:300000 },
//   { month: "AUG", totalRevenue: 1500000, paymentsReceived: 500000, otherSalesColor:800000},
//   { month: "SEP", totalRevenue: 2500000, paymentsReceived: 800000,otherSalesColor:700000 },
//   { month: "OCT", totalRevenue: 3500000, paymentsReceived: 1200000,otherSalesColor:500000 },
//   { month: "NOV", totalRevenue: 4500000, paymentsReceived: 2000000,otherSalesColor:600000 },
//   { month: "DEC", totalRevenue: 1000000, paymentsReceived: 500000 ,otherSalesColor:700000},
// ];
// // --- Y-AXIS CONFIGURATION ---

// // Custom ticks array: 0, 50K, 100K, 500K, 1M, 5M
// const customTicks = [0, 50000, 100000, 500000, 1000000, 5000000];
// const maxYValue = 5000000;

// const formatYAxis = (tick: number): string => {
//   if (tick >= 1000000) {
//     // e.g., 5,000,000 -> 5M
//     return `${tick / 1000000}M`;
//   }
//   if (tick >= 1000) {
//     // e.g., 50,000 -> 50K
//     return `${tick / 1000}K`;
//   }
//   // Ensure 0 is returned as a string
//   return String(tick);
// };
// // ----------------------------

// const SalesChart: React.FC = () => {
//   const theme = useTheme();
// const [timeRange, setTimeRange] = useState<'Daily' | 'Weekly' | 'Annually'>('Annually');

//   // Handler for the ToggleButtonGroup change
//   const handleRangeChange = (
//     event: React.MouseEvent<HTMLElement>,
//     newRange: 'Daily' | 'Weekly' | 'Annually' | null,
//   ) => {
//     if (newRange !== null) {
//       setTimeRange(newRange);
//       // NOTE: In a real app, you would fetch or filter data here 
//       // based on the newRange value (e.g., fetchDailyData(), etc.)
//       console.log(`Time range changed to: ${newRange}`);
//     }
//   };
//   // Define colors to match the chart image appearance
//   const totalRevenueColor =
//     theme.palette.mode === "light" ? "#962DFF" : "#B39DDB"; // Purple
//   const paymentsReceivedColor =
//     theme.palette.mode === "light" ? "#FF718B" : "#FFAB91"; // Red/Pink  
//  const otherSalesColor =
//     theme.palette.mode === "light" ? "#93AAFD" : "#93AAFD"; 
//   return (
//     <>
//       {/* --- Header Section: Title and Buttons --- */}
//       <Stack
//         direction="row"
//         justifyContent="space-between"
//         alignItems="center"
//         mb={2}
//       >
//         <Typography variant="h6" sx={{ fontWeight: 400, color: "#9291A5" }}>
//           Statistics
//         </Typography>
//         <Stack direction="row" spacing={1}>
         
//           <ToggleButtonGroup
//             value={timeRange}
//             exclusive
//             onChange={handleRangeChange}
//             size="small"
//             sx={{
//               gap: "0.2rem",
//               backgroundColor: "#f5f5f5",
//               borderRadius: "16px",
//               padding: "10px",
//               "& .MuiToggleButton-root": {
//                 border: "none",
//                 borderRadius: "8px",
//                 textTransform: "none",
//                 fontWeight: 500,
//                 fontSize: "0.85rem",
//                 color: "#555",
//                 padding: "8px 17px",
//                 "&:hover": {
//                   backgroundColor: "#e0e0e0",
//                 },
//               },
//               "& .MuiToggleButton-root.Mui-selected": {
//                 backgroundColor: "#098963",
//                 color: "white",
//                 "&:hover": {
//                   backgroundColor: "#098963",
//                 },
//               },
//             }}
//           >
//             <ToggleButton value="Daily">7 Days</ToggleButton>
//             <ToggleButton value="Weekly">30 Days</ToggleButton>
//             <ToggleButton value="Annually">12 Months</ToggleButton>
//           </ToggleButtonGroup>
//         </Stack>
        
//       </Stack>

//       {/* --- Revenue Trend Title and Stats --- */}
//       <Stack direction="row" alignItems="center" spacing={1} mb={4}>
//         <Typography variant="h6" sx={{ fontWeight: 700, color: "#1E1B39" }}>
//          Sales Report
//         </Typography>
//       </Stack>
//       <Divider sx={{ mb: 2 }} />

//       {/* --- Chart Area --- */}
//       <Box sx={{ height: 400 }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <LineChart
//             data={data}
//             // Increased 'bottom' margin to ensure the '0' tick label is visible
//             margin={{ top: 10, right: 30, left: 10, bottom: 70 }}
//           >
//             {/* Grid Lines: Horizontal only, dashed */}
//             <CartesianGrid
//               vertical={false}
//               strokeDasharray="3 3"
//               stroke="#e0e0e0"
//             />

//             {/* X-Axis: Months */}
//             <XAxis dataKey="month" axisLine={false} tickLine={false} />

//             {/* Y-Axis: Custom Ticks and Formatting (K/M) */}
//             <YAxis
//               ticks={customTicks}
//               tickFormatter={formatYAxis}
//               axisLine={false} // Hide the main axis line
//               tickLine={false} // Hide tick lines
//               domain={[0, maxYValue]} // Force domain to start at 0 and max at 5M
//               tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
//             />

//             <Tooltip
//               formatter={(value: number) => `$${value.toLocaleString()}`}
//             />

//             <Legend
//               verticalAlign="bottom"
//               align="left"
//               wrapperStyle={{ paddingTop: "20px" }}
//               iconType="circle"
//             />

//             {/* Line 1: Total Revenue (Solid, Purple) */}
//             <Line
//               type="monotone"
//               dataKey="totalRevenue"
//               name="Medicine Sales"
//               stroke={totalRevenueColor}
//               strokeDasharray="8 8" // Creates the dashed line effect
//               dot={false}
//               strokeWidth={3}
//             />

//             {/* Line 2: Payments Received (Dashed, Red/Pink) */}
//             <Line
//               type="monotone"
//               dataKey="paymentsReceived"
//               name="Healthcare Product Sales"
//               stroke={paymentsReceivedColor}
//               strokeDasharray="8 8" // Creates the dashed line effect
//               dot={false}
//               strokeWidth={3}
//             />
//               <Line
//               type="monotone"
//               dataKey="paymentsReceived"
//               name="Other Sales"
//               stroke={otherSalesColor}
//               strokeDasharray="8 8" // Creates the dashed line effect
//               dot={false}
//               strokeWidth={3}
//             />
//           </LineChart>
//         </ResponsiveContainer>
//       </Box>
//     </>
//   );
// };

// export default SalesChart;








import React, { useState, useEffect, useCallback } from "react";
import { Box, Card, Typography, ToggleButton, ToggleButtonGroup, CircularProgress, Alert } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { callAPI, Method, getLocalValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";

interface SalesDataPoint {
  name: string;
  medicineSales: number;  
  healthcareSales: number; 
  otherSales: number;
}

const SalesBarChart: React.FC = () => {
  const [mode, setMode] = useState<"7days" | "30days" | "12months">("30days");
  const [chartData, setChartData] = useState<SalesDataPoint[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [vendorId, setVendorId] = useState<string>(""); // 👈 ADDED

  // 👈 ADDED - Get vendorId from localStorage (same as RecentPrescriptionOrder)
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 LOADED VENDOR ID:", userId);
    setVendorId(userId || "");
  }, []);

  const transformApiData = (apiData: any[]): SalesDataPoint[] => {
    if (!apiData || !Array.isArray(apiData)) return [];
    return apiData.map(item => ({
      name: item.label || item.name || item.date || 'N/A',
      medicineSales: Number(item.medicineSales) || 0,
      healthcareSales: Number(item.healthcareSales) || 0,
      otherSales: Number(item.otherSales) || 0,
    }));
  };

  const fetchData = useCallback(async (mode: string) => {
    // 👈 UPDATED - Check for vendorId before API call
    if (!vendorId) {
      console.log("⏳ Waiting for vendorId...");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const endpoint = `/pharmacy/Ph_Order_/category-salesReport?vendorId=${vendorId}&range=${mode}`;
      console.log(`🔍 Calling: ${endpoint}`);
      
      const response = await callAPI(endpoint, Method.GET);
      console.log(`📡 API Response:`, response);
      
      if (response.status && response.data) {
        const transformedData = transformApiData(response.data);
        setChartData(transformedData);
        
        if (transformedData.length === 0) {
         console.warn(`⚠️ No data for ${mode}`);
         setError(`No sales data for ${mode}`);
        } else {
         console.log(`✅ Loaded ${transformedData.length} items`);
        }
      }
    } catch (error: any) {
      console.error(`💥 Error:`, error);
      setError(`Failed to load data`);
      setChartData([]);
    } finally {
      setLoading(false);
    }
  }, [vendorId]); // 👈 ADDED vendorId dependency

  useEffect(() => {
    fetchData(mode);
  }, [fetchData, mode]);

  const handleMode = (_: any, newMode: "7days" | "30days" | "12months" | null) => {
    if (newMode) setMode(newMode);
  };

  const getModeDisplayName = (mode: string) => {
    const names = { "7days": "7 Days", "30days": "30 Days", "12months": "12 Months" };
    return names[mode as keyof typeof names] || mode;
  };

  return (
    <Card sx={{ p: 3, borderRadius: 4, boxShadow: "0 4px 20px rgba(0,0,0,0.05)", width: "100%" }}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography fontSize={14} color="grey.600">Statistics</Typography>
          <Typography fontSize={18} fontWeight={600}>
            Total summary of sales ({getModeDisplayName(mode)})
          </Typography>
        </Box>

        <ToggleButtonGroup value={mode} exclusive onChange={handleMode} size="small" sx={{
          gap: "0.2rem", backgroundColor: "#f5f5f5", borderRadius: "16px", padding: "10px",
          "& .MuiToggleButton-root": {
            border: "none", borderRadius: "8px", textTransform: "none", fontWeight: 500,
            fontSize: "0.85rem", color: "#555", padding: "8px 17px", "&:hover": { backgroundColor: "#e0e0e0" },
          },
          "& .MuiToggleButton-root.Mui-selected": { 
            backgroundColor: "#098963", color: "white", "&:hover": { backgroundColor: "#098963" } 
          },
        }}>
          <ToggleButton value="7days">7 Days</ToggleButton>
          <ToggleButton value="30days">30 Days</ToggleButton>
          <ToggleButton value="12months">12 Months</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Content */}
      <Box sx={{ mt: 3, minHeight: 380 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 320, flexDirection: 'column', gap: 2 }}>
            <CircularProgress size={28} />
            <Typography>Loading {getModeDisplayName(mode)}...</Typography>
          </Box>
        ) : error ? (
          <Alert severity="warning" sx={{ mt: 2 }}>
            <strong>No sales data available</strong> for {getModeDisplayName(mode)}
          </Alert>
        ) : chartData.length === 0 ? (
          <Box sx={{ textAlign: 'center', p: 4, color: 'text.secondary' }}>
            <Typography variant="h6">No Data</Typography>
            <Typography>No sales recorded</Typography>
          </Box>
        ) : (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box sx={{ width: "78%", height: 320 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} barGap={8}>
                  <CartesianGrid stroke="#E4E4E4" strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#6B7280" }} axisLine={false} tickLine={false} />
                  <YAxis tick={{ fontSize: 12, fill: "#6B7280" }} axisLine={false} tickLine={false} tickFormatter={(v) => `${v/1000}K`} />
                  <Tooltip cursor={{ fill: "rgba(0,0,0,0.04)" }} formatter={(value: number) => [`₹${value.toLocaleString()}`, "Sales"]} />
                  
                  <Bar dataKey="medicineSales" radius={[6, 6, 0, 0]} fill="#D5B2FF" maxBarSize={24} name="Medicine Sales" />
                  <Bar dataKey="healthcareSales" radius={[6, 6, 0, 0]} fill="#4A1CFF" maxBarSize={24} name="Healthcare Sales" />
                  <Bar dataKey="otherSales" radius={[6, 6, 0, 0]} fill="#10B981" maxBarSize={24} name="Other Sales" />
                </BarChart>
              </ResponsiveContainer>
            </Box>

            <Box display="flex" flexDirection="column" gap={2} sx={{ pr: 2 }}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box sx={{ width: 12, height: 12, bgcolor: "#D5B2FF", borderRadius: "50%" }} />
                <Typography fontSize={14} color="grey.700">Medicine Sales</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Box sx={{ width: 12, height: 12, bgcolor: "#4A1CFF", borderRadius: "50%" }} />
                <Typography fontSize={14} color="grey.700">Healthcare Sales</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Box sx={{ width: 12, height: 12, bgcolor: "#10B981", borderRadius: "50%" }} />
                <Typography fontSize={14} color="grey.700">Other Sales</Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default SalesBarChart;
